import { Tag, TagType, Text, colors } from "@asurion-core/mx-asurion-ui-react";
import { BetaIcon, Contact, DetailsContainer, DetailsWrapperContainer, HighlightText } from "@ubif/components";
import { getAppointmentDate, getArrivalStatusNameAndTagType } from "@ubif/util-store";
import styled from "styled-components";

import { FlexContactWrapperContainer, FlexNameWrapperContainer } from "./FlexContainers";
import { QuickSearchCustomerDetailsProps } from "./QuickSearchCustomerDetails";

type QuickSearchArrivalDetailsProps = Omit<
  QuickSearchCustomerDetailsProps,
  "firstName" | "lastName" | "customerId" | "highlightText" | "onClick"
> & {
  arrival: {
    arrivalId: number;
    arrivalStatusId: number;
    appointment: string;
    isMissed?: boolean;
  };
  deviceName: string;
  modelName: string;
  onClick: (id: number) => void;
};

export const QuickSearchArrivalDetails = ({
  fullName,
  email,
  phone,
  canEmail,
  canSms,
  canCall,
  preferredContactLabel,
  arrival,
  deviceName,
  modelName,
  onClick,
  storeTimeZone
}: QuickSearchArrivalDetailsProps) => {
  const handleClick = () => {
    onClick(arrival.arrivalId);
  };

  const arrivalStatusNameAndType = getArrivalStatusNameAndTagType(arrival.arrivalStatusId, arrival.isMissed);

  return (
    <StyledQuickSearchArrivalDetails onClick={handleClick}>
      <BetaIcon aria-hidden="true" fill={colors.neutralDeepest} size="medium" src="time/calendar-dollar-2" />
      <DetailsContainer>
        <FlexNameWrapperContainer>
          <HighlightText highlightText={fullName} wholeText={fullName} className="fs-mask" />
          <Text size={2}>{`| ${getAppointmentDate(arrival.appointment, storeTimeZone)} | `}</Text>
          <Text size={2}>{`${deviceName} ${modelName}`}</Text>
        </FlexNameWrapperContainer>
        <FlexContactWrapperContainer>
          {email ? (
            <Contact
              icon="email"
              text={email}
              canEmail={canEmail}
              preferredContactLabel={preferredContactLabel}
              className="fs-mask"
            />
          ) : null}
          {phone ? (
            <Contact
              icon="call"
              text={phone}
              canSms={canSms}
              canCall={canCall}
              preferredContactLabel={preferredContactLabel}
              className="fs-mask"
            />
          ) : null}
          <Tag text={arrivalStatusNameAndType.name} type={arrivalStatusNameAndType.tagType as TagType} />
        </FlexContactWrapperContainer>
      </DetailsContainer>
    </StyledQuickSearchArrivalDetails>
  );
};

const StyledQuickSearchArrivalDetails = styled(DetailsWrapperContainer)`
  background-color: var(--aui-elevated-level-01);
  color: var(--aui-on-surface);

  &:hover {
    background-color: var(--aui-outline-soft);
    border-radius: 0.5rem;
    cursor: pointer;
  }
`;
